// extracted by css-extract-rspack-plugin
export default {"Mark":"Slider-module__Mark___bXnAj"};